import React from 'react';
import styled from 'styled-components';
import { throttle } from 'lodash-es';
import * as styles from './styles';
import { OnlineButton } from '@sunbit-dev/web-ui-lib';
import { ActionButtonProps } from './models';

export const ActionButton = styled(({ submit: _submit, ...props }: ActionButtonProps) => {
  const submit = throttle(_submit, 300, { trailing: false });
  return <OnlineButton {...{ ...props, submit }} />;
})`
  ${styles.ActionButton}
`;
